// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportMainDiv {
  border-radius: 16px;
  width: 100%;
}

.reportNameField.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  width: 320px !important;
}

.generateReportBtn.MuiButtonBase-root.MuiButton-root {
  border-radius: 8px;
  background: var(--generic-primary-accent, #403e9f);
  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
  padding: 8px 15px;
  margin-left: 8px
}

.marginTopTwenty {
  margin-top: 20px;
}

.checkbox.MuiButtonBase-root.MuiCheckbox-root {
  width: 16px;
  color: #403e9f;
  margin-right: 8px;
}

.cancelBtn.MuiButtonBase-root.MuiButton-root {
  border-radius: 8px;
  border: 1px solid var(--generic-primary-accent, #403e9f);
  background: var(--conditional-pop-over, #fff);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  text-transform: none;
  color: var(--generic-primary-accent, #403e9f);
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin-right: 8px;
  padding: 8px 15px;
}

.radioBtn .MuiSvgIcon-root {
  width: 16px !important;
  display: block;
  margin-bottom: 4px;
}

.radioLabels.MuiFormControlLabel-root .MuiFormControlLabel-label {
  color: var(--text-low, rgba(1, 1, 2, 0.45));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.buttonPosition {
  display: flex;
  justify-content: end;
  margin-bottom: 10px !important;
}

.selectedFieldStyling.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;
  font-weight: 500;
}

.calendarDiv .MuiInputBase-root.MuiOutlinedInput-root {
  width: 320px !important;
  height: 40px !important;
}

.calendarDiv .MuiFormControl-root.MuiTextField-root {
  margin-left: 20px !important;
}

.selectedRadioColor.MuiFormControlLabel-root .MuiFormControlLabel-label {
  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;
  font-weight: 500 !important;
}

.errorStyling {
  display: flex;
  align-items: center;
}

.errorMessage.MuiTypography-root {
  color: var(--comms-negative, #b9232f);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.errorImg {
  height: 12px;
  width: 12px;
  margin-right: 2px;
}

.selectProcessor {
  color: var(--text-low, rgba(1, 1, 2, 0.45)) !important;
}

.inputFieldSearch .MuiInputBase-root.MuiOutlinedInput-root {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  padding-left: 12px !important;
}

.countValueDiv {
  background-color: var(--fexco-black-85, #262626);
  border-radius: 50px;
  height: 22px;
  width: 22px;
  color: white;
  margin-right: 5px;
  margin-left: -8px;
  font-size: 14px;
  font-weight: 500;
  font-family: Poppins;
  padding-bottom: 22px;
}

.modalCrossIcon {
  width: 20px;
  height: 20px;
  border: 2px;
  color: black;
}

.menuItemStyle {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85)) !important;
  font-family: Poppins !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

/* modal styling */
.refundModal .MuiPaper-root.MuiDialog-paper {
  padding-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  width: 640px;
  border-radius: 16px;
  height: 388px;
}

.clearBtn.MuiButtonBase-root.MuiButton-root {
  color: rgba(36, 183, 170, 1);
  margin-right: 10px;
  text-transform: none;
  font-size: 14px;
  height: 36px;
  width: 91px;
  font-weight: 500;
  border-radius: 8px;
  border: 2px solid;
  padding: 15px 8px;
  font-family: Poppins;
  border: 1px solid var(--generic-primary, #24b7aa);
  background: var(--conditional-pop-over, #fff);
}

.applyBtn.MuiButtonBase-root.MuiButton-root {
  font-weight: 500;
  border: 1px solid var(--generic-primary, #24b7aa);
  background: var(--generic-primary, #24b7aa);
  border-radius: 8px;
  text-transform: none;
  font-size: 14px;
  height: 36px;
  width: 91px;
  padding: 15px 8px;
  font-family: Poppins;
}

.responsive-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.report-section {
  flex: 1;
}

.reportCheckbox .MuiSvgIcon-root {
  height: 16px !important;
  width: 16px !important;
}

@media screen and (max-width: 768px) {
  .report-section {
    flex: 1 0 100%;
  }
}

.reportsModal .MuiPaper-root.MuiDialog-paper {
  width: 640px;
  border-radius: 16px;
  height: 388px;
}

.report-tooltip .MuiButtonBase-root.MuiIconButton-root {
  padding: 0px !important;
  margin-left: 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/reports/reports.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,6DAA6D;EAC7D,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;EACxD,6CAA6C;EAC7C,+CAA+C;EAC/C,oBAAoB;EACpB,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gEAAgE;EAChE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B","sourcesContent":[".reportMainDiv {\n  border-radius: 16px;\n  width: 100%;\n}\n\n.reportNameField.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {\n  width: 320px !important;\n}\n\n.generateReportBtn.MuiButtonBase-root.MuiButton-root {\n  border-radius: 8px;\n  background: var(--generic-primary-accent, #403e9f);\n  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n  padding: 8px 15px;\n  margin-left: 8px\n}\n\n.marginTopTwenty {\n  margin-top: 20px;\n}\n\n.checkbox.MuiButtonBase-root.MuiCheckbox-root {\n  width: 16px;\n  color: #403e9f;\n  margin-right: 8px;\n}\n\n.cancelBtn.MuiButtonBase-root.MuiButton-root {\n  border-radius: 8px;\n  border: 1px solid var(--generic-primary-accent, #403e9f);\n  background: var(--conditional-pop-over, #fff);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  text-transform: none;\n  color: var(--generic-primary-accent, #403e9f);\n  text-align: center;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  margin-right: 8px;\n  padding: 8px 15px;\n}\n\n.radioBtn .MuiSvgIcon-root {\n  width: 16px !important;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.radioLabels.MuiFormControlLabel-root .MuiFormControlLabel-label {\n  color: var(--text-low, rgba(1, 1, 2, 0.45));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.buttonPosition {\n  display: flex;\n  justify-content: end;\n  margin-bottom: 10px !important;\n}\n\n.selectedFieldStyling.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;\n  font-weight: 500;\n}\n\n.calendarDiv .MuiInputBase-root.MuiOutlinedInput-root {\n  width: 320px !important;\n  height: 40px !important;\n}\n\n.calendarDiv .MuiFormControl-root.MuiTextField-root {\n  margin-left: 20px !important;\n}\n\n.selectedRadioColor.MuiFormControlLabel-root .MuiFormControlLabel-label {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;\n  font-weight: 500 !important;\n}\n\n.errorStyling {\n  display: flex;\n  align-items: center;\n}\n\n.errorMessage.MuiTypography-root {\n  color: var(--comms-negative, #b9232f);\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.errorImg {\n  height: 12px;\n  width: 12px;\n  margin-right: 2px;\n}\n\n.selectProcessor {\n  color: var(--text-low, rgba(1, 1, 2, 0.45)) !important;\n}\n\n.inputFieldSearch .MuiInputBase-root.MuiOutlinedInput-root {\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n  padding-left: 12px !important;\n}\n\n.countValueDiv {\n  background-color: var(--fexco-black-85, #262626);\n  border-radius: 50px;\n  height: 22px;\n  width: 22px;\n  color: white;\n  margin-right: 5px;\n  margin-left: -8px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Poppins;\n  padding-bottom: 22px;\n}\n\n.modalCrossIcon {\n  width: 20px;\n  height: 20px;\n  border: 2px;\n  color: black;\n}\n\n.menuItemStyle {\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85)) !important;\n  font-family: Poppins !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n\n/* modal styling */\n.refundModal .MuiPaper-root.MuiDialog-paper {\n  padding-top: 24px;\n  padding-left: 32px;\n  padding-right: 32px;\n  width: 640px;\n  border-radius: 16px;\n  height: 388px;\n}\n\n.clearBtn.MuiButtonBase-root.MuiButton-root {\n  color: rgba(36, 183, 170, 1);\n  margin-right: 10px;\n  text-transform: none;\n  font-size: 14px;\n  height: 36px;\n  width: 91px;\n  font-weight: 500;\n  border-radius: 8px;\n  border: 2px solid;\n  padding: 15px 8px;\n  font-family: Poppins;\n  border: 1px solid var(--generic-primary, #24b7aa);\n  background: var(--conditional-pop-over, #fff);\n}\n\n.applyBtn.MuiButtonBase-root.MuiButton-root {\n  font-weight: 500;\n  border: 1px solid var(--generic-primary, #24b7aa);\n  background: var(--generic-primary, #24b7aa);\n  border-radius: 8px;\n  text-transform: none;\n  font-size: 14px;\n  height: 36px;\n  width: 91px;\n  padding: 15px 8px;\n  font-family: Poppins;\n}\n\n.responsive-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.report-section {\n  flex: 1;\n}\n\n.reportCheckbox .MuiSvgIcon-root {\n  height: 16px !important;\n  width: 16px !important;\n}\n\n@media screen and (max-width: 768px) {\n  .report-section {\n    flex: 1 0 100%;\n  }\n}\n\n.reportsModal .MuiPaper-root.MuiDialog-paper {\n  width: 640px;\n  border-radius: 16px;\n  height: 388px;\n}\n\n.report-tooltip .MuiButtonBase-root.MuiIconButton-root {\n  padding: 0px !important;\n  margin-left: 2px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
